<template>
    <div>
        <b-card
            header="Claimants"
            header-text-variant="white"
            header-bg-variant="info"
        >
            <b-table :items="items" :fields="fields">
                <template v-slot:cell(client_name)="row">
                    <a v-if="admin" :href="`${claimantUrlPrefix}/${row.item.id}`" targert="_blank">{{ row.item.firstname }} {{ row.item.lastname}}</a>
                    <span v-else>{{ row.item.firstname }} {{ row.item.lastname}}</span>
                </template>
                <template v-slot:cell(address)="row">
                    {{ formatAddress(row.item.evv_address) }}
                </template>
                <template v-slot:cell(phone)="row">
                    {{ row.item.evv_phone ? row.item.evv_phone.number : '-' }}
                </template>
                <template v-slot:cell(rate)="row">
                    ${{ row.item.pivot.caregiver_hourly_rate }}
                </template>
            </b-table>
        </b-card>
    </div>
</template>

<script>

    import UsesRole from '../../mixins/UsesRole';

    export default {

        mixins : [ UsesRole ],
        props  : {

            caregiver : {},
            admin     : false,
        },

        data() {
            return {
                form: new Form({
                    firstname: "",
                    lastname: "",
                    email: "",
                    rate: "0.00"
                }),
                items: [],
                fields: [
                    "client_name",
                    "address",
                    "phone", 
                    "rate",
                ]
            };
        },

        methods: {
            formatAddress(address) {
                if (! address) {
                    return '-';
                }

                return `${address.address1} ${address.city}, ${address.state} ${address.zip}`;
            },
        },

        mounted() {
            this.items = (this.caregiver.clients) ? this.caregiver.clients  : this.caregiver.carrier_manager_clients;
        },

        watch: {
            caregiver() {
                
                this.items = (this.caregiver.clients) ? this.caregiver.clients  : this.caregiver.carrier_manager_clients;
            },
        },
    };
</script>

<style>
th.hourly,
td.hourly {
    background-color: #eee;
}

th.daily,
td.daily {
    background-color: #f5f5f5;
}

thead th {
    padding: 0.4rem 0.75rem !important;
}

tr td.hourly,
tr th.hourly {
    text-align: center;
}
</style>